<section class="wareneingang-detail-page">
    @if (isLoading()) {
    <header class="detail-header detail-header-skeleton">
        <div class="detail-title-row">
            <span class="skeleton-line skeleton-back-icon"></span>
            <span class="skeleton-line skeleton-detail-title"></span>
            <span class="skeleton-line skeleton-status-pill"></span>
        </div>

        <span class="skeleton-line skeleton-detail-subtitle"></span>
    </header>

    <section class="kpi-grid">
        @for (_ of skeletonKpiCards; track $index) {
        <div class="kpi-card kpi-card-skeleton">
            <span class="skeleton-line skeleton-kpi-label"></span>
            <strong class="skeleton-line skeleton-kpi-value"></strong>
        </div>
        }
    </section>

    <section class="toolbar toolbar-skeleton">
        <div class="search-box search-box-skeleton">
            <span class="skeleton-line skeleton-icon"></span>
            <span class="skeleton-line skeleton-search"></span>
        </div>
    </section>

    <section class="detail-table">
        <div class="table-header">
            <button type="button" class="table-sort-button"
                [class.table-sort-button-active]="isDetailSortActive('artikel')" (click)="setDetailSort('artikel')">
                <span>Artikel</span>
                <mat-icon class="sort-chevron" fontSet="material-icons-outlined">
                    {{ getDetailSortIcon('artikel') }}
                </mat-icon>
            </button>

            <span>Offene Menge</span>
            <span>Liefermenge</span>
            <span>IstMenge</span>
        </div>

        <div class="table-body table-body-grouped">
            @for (_ of skeletonRows; track $index) {
            <div class="table-row table-row-skeleton">
                <div class="cell">
                    <span class="skeleton-line skeleton-title"></span>
                    <span class="skeleton-line skeleton-subtitle"></span>
                </div>

                <div class="cell">
                    <span class="skeleton-line skeleton-short"></span>
                </div>

                <div class="cell">
                    <span class="skeleton-line skeleton-short"></span>
                </div>

                <div class="cell">
                    <span class="skeleton-line skeleton-editor"></span>
                </div>
            </div>
            }
        </div>
    </section>
    } @else {
    @if (wareneingang(); as item) {
    <header class="detail-header">
        <div class="detail-title-row">
            <button type="button" class="header-back-icon" (click)="goBack()" aria-label="Zur Übersicht">
                <mat-icon fontSet="material-icons-outlined">arrow_back</mat-icon>
            </button>

            <h1>{{ item.lieferscheinnummer }}</h1>

            <span class="status-pill detail-status-pill" [ngClass]="getStatusClass(item.status)">
                {{ getStatusLabel(item.status) }}
            </span>
        </div>

        <p class="detail-subtitle">
            {{ formatDisplayDate(item.wareneingangTag) }} • {{ item.filialNummer }} • {{ item.filialeName }}
        </p>
    </header>

    <section class="kpi-grid">
        <div class="kpi-card">
            <span>Positionen</span>
            <strong>{{ kpis().positionen }}</strong>
        </div>

        <div class="kpi-card">
            <span>Liefermenge gesamt</span>
            <strong>{{ kpis().liefermengeGesamt }}</strong>
        </div>

        <div class="kpi-card" [class.kpi-card-attention]="
        kpis().istMengeGesamt !== kpis().liefermengeGesamt
    ">
            <span>IstMenge gesamt</span>
            <strong>{{ kpis().istMengeGesamt }}</strong>
        </div>

        <div class="kpi-card" [class.kpi-card-success]="kpis().abweichungen === 0"
            [class.kpi-card-attention]="kpis().abweichungen > 0">
            <span>Korrekturen</span>
            <strong>{{ kpis().abweichungen }}</strong>
        </div>
    </section>

    <section class="toolbar">
        <div class="search-box">
            <mat-icon fontSet="material-icons-outlined">search</mat-icon>

            <input type="text" placeholder="Artikel suchen..." [value]="searchTerm()"
                (input)="searchTerm.set(($any($event.target)).value)" />

            @if (searchTerm()) {
            <button type="button" class="search-clear-button" aria-label="Suche zurücksetzen"
                (click)="searchTerm.set('')">
                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            </button>
            }
        </div>

        @if (!isEditMode()) {
        <button type="button" class="primary-button edit-button" [disabled]="!canStartEdit()" (click)="startEdit()">
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            Bearbeiten
        </button>

        @if (editDisabledHint(); as hint) {
        <small class="edit-disabled-hint">
            {{ hint }}
        </small>
        }
        }

        @if (isEditMode()) {
        <div class="toolbar-actions">
            <button type="button" class="secondary-button" (click)="openAddArtikelDialog()">
                <mat-icon fontSet="material-icons-outlined">add</mat-icon>
                Artikel hinzufügen
            </button>

            <button type="button" class="secondary-button" (click)="cancelEdit()">
                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
                Abbrechen
            </button>

            <button type="button" class="primary-button" (click)="save()">
                <mat-icon fontSet="material-icons-outlined">save</mat-icon>
                Speichern
            </button>
        </div>
        }
    </section>

    <section class="detail-table">
        @if (!displayedPositionen().length) {
        <div class="empty-state">Keine Artikel im aktuellen Suchergebnis gefunden.</div>
        } @else {
        <div class="table-header">
            <button type="button" class="table-sort-button"
                [class.table-sort-button-active]="isDetailSortActive('artikel')" (click)="setDetailSort('artikel')">
                <span>Artikel</span>
                <mat-icon class="sort-chevron" fontSet="material-icons-outlined">
                    {{ getDetailSortIcon('artikel') }}
                </mat-icon>
            </button>

            <span>Offene Menge</span>
            <span>Liefermenge</span>
            <span>IstMenge</span>
        </div>

        <div class="table-body table-body-grouped">
            @for (group of groupedPositionen(); track group.warengruppe) {
            @if (group.warengruppe) {
            <div class="group-row">
                {{ group.warengruppe }}
            </div>
            }

            @for (position of group.positionen; track position.artikelnummer) {
            <div class="table-row">
                <div class="cell artikel-cell">
                    <strong>{{ position.artikelname }}</strong>
                    <small>Stück</small>
                </div>

                <div class="cell number-cell open-amount-cell">
                    <span>{{ getOffeneMenge(position) }}</span>
                </div>

                <div class="cell number-cell">
                    <span>{{ position.liefermenge }}</span>
                </div>

                <div class="cell number-cell ist-cell">
                    @if (isEditMode()) {
                    <div class="quantity-editor">
                        <button type="button" (click)="decreaseIstMenge(position)">−</button>

                        <input type="number" min="0" [value]="position.istMenge ?? ''"
                            [placeholder]="position.liefermenge.toString()"
                            (input)="updateIstMengeFromInput(position.artikelnummer, $event)" />

                        <button type="button" (click)="increaseIstMenge(position)">+</button>
                    </div>
                    } @else {
                    <span class="ist-menge-display">
                        {{ getIstMengeDisplayValue(position) }}

                        @if (getIstMengeDifference(position) !== 0) {
                        <strong class="ist-menge-difference"
                            [class.ist-menge-difference-positive]="getIstMengeDifference(position) > 0"
                            [class.ist-menge-difference-negative]="getIstMengeDifference(position) < 0">
                            ({{ formatIstMengeDifference(position) }})
                        </strong>
                        }
                    </span>
                    }
                </div>
            </div>
            }
            }
        </div>
        }
    </section>

    @if (isEditMode()) {
    <section class="detail-footer-actions">
        <button type="button" class="success-button complete-bottom-button" (click)="complete()">
            <mat-icon fontSet="material-icons-outlined">task_alt</mat-icon>
            Wareneingang abschließen
        </button>
    </section>
    }

    @if (isAddArtikelDialogOpen()) {
    <div class="dialog-backdrop" (click)="closeAddArtikelDialog()"></div>

    <section class="dialog-panel" role="dialog" aria-modal="true">
        <header class="dialog-header">
            <h2>Artikel zum Wareneingang hinzufügen</h2>

            <button type="button" class="close-button" (click)="closeAddArtikelDialog()">
                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            </button>
        </header>

        <div class="dialog-search">
            <mat-icon fontSet="material-icons-outlined">search</mat-icon>

            <input type="text" placeholder="Artikel suchen..." [value]="artikelSucheTerm()"
                (input)="updateArtikelSucheTerm(($any($event.target)).value)" />

            @if (artikelSucheTerm()) {
            <button type="button" class="dialog-search-clear-button" aria-label="Suche zurücksetzen"
                (click)="artikelSucheTerm.set('')">
                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            </button>
            }
        </div>

        <div class="article-list">
            @if (!artikelSuchergebnisse().length) {
            <div class="dialog-empty-state">
                @if (artikelSucheTerm().trim()) {
                <mat-icon fontSet="material-icons-outlined">search_off</mat-icon>
                }

                <span>
                    {{
                    artikelSucheTerm().trim()
                    ? 'Kein Artikel gefunden.'
                    : 'Alle verfügbaren Artikel sind bereits im Wareneingang.'
                    }}
                </span>
            </div>
            } @else {
            @for (artikel of artikelSuchergebnisse(); track artikel.artikelnummer) {
            <article class="article-option">
                <div class="article-info">
                    <span class="article-number">{{ artikel.artikelnummer }}</span>

                    <div>
                        <strong>{{ artikel.artikelname }}</strong>
                        <small>{{ artikel.warengruppe }}</small>
                    </div>
                </div>

                <button type="button" class="add-button" (click)="addArtikel(artikel)">
                    <mat-icon fontSet="material-icons-outlined">add</mat-icon>
                    Hinzufügen
                </button>
            </article>
            }
            }
        </div>
    </section>

    @if (artikelAddFeedback(); as feedback) {
    <div class="article-add-feedback" role="status" aria-live="polite">
        <div class="article-add-feedback-content">
            <mat-icon fontSet="material-icons-outlined">check_circle</mat-icon>

            <div class="article-add-feedback-text">
                <strong>{{ feedback.artikelname }} wurde hinzugefügt.</strong>
                <span>Bitte speichern, damit die Änderung übernommen wird.</span>
            </div>
        </div>

        <button type="button" class="article-add-feedback-close" aria-label="Hinweis schließen"
            (click)="clearArtikelAddFeedback()">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
    </div>
    }
    }
    }
    }
</section>